import * as React from 'react';

import InfoIcon from '@hero/ui-kit/icons/utility/InfoIcon';
import * as Style from './style.module.scss';

const DeviceInfo: React.FC = () => {
    return (
        <div className={Style.infoHeader}>
            <div style={{ minWidth: '24px' }}>
                <InfoIcon height={22} width={20} type="utility" />
            </div>

            <div className={Style.infoText}>
                In order to validate their Hero membership, ask the member to provide the following
                information by navigating on Hero dispenser to{' '}
                <strong>{'Main Menu > Device Settings > About > Device info'}</strong>
            </div>
        </div>
    );
};

export default DeviceInfo;
